function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.45,
    height: 19.472,
    viewBox: "0 0 19.45 19.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6662",
    d: "M279.344 74.062v-9.1h-1.521v9.1a3.4 3.4 0 0 0 0 6.617v3.752h1.521v-3.752a3.4 3.4 0 0 0 0-6.617z",
    transform: "translate(-268.859 -64.96)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6663",
    d: "M139.344 68.713v-3.752h-1.521v3.752a3.4 3.4 0 0 0 0 6.617v9.1h1.521v-9.1a3.4 3.4 0 0 0 0-6.617z",
    transform: "translate(-135.197 -64.961)",
    style: {
      fill: "#aeaeae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6664",
    d: "M419.344 68.713v-3.752h-1.521v3.752a3.4 3.4 0 0 0 0 6.617v9.1h1.521v-9.1a3.4 3.4 0 0 0 0-6.617z",
    transform: "translate(-402.52 -64.961)",
    style: {
      fill: "#aeaeae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default __webpack_public_path__ + "static/media/levels.a7263f048078b6bc4f88896bc58a10ed.svg";
export { ForwardRef as ReactComponent };